import { useAuth } from "../../lib/auth/use-auth";
import { COUNTRIES, type Country } from "./types";

export function useDefaultCountry(): Country | null {
  const { claims } = useAuth();
  const claimed = String(claims?.country ?? "").toLowerCase();
  return COUNTRIES.includes(claimed as Country) ? (claimed as Country) : null;
}
